// extracted by mini-css-extract-plugin
export default {"question":"Question_question__RT-qm","confirmation":"Question_confirmation__kid6b","recording":"Question_recording__hfsl1"};